import { render, staticRenderFns } from "./AppDropDownList.vue?vue&type=template&id=10c5118e"
import script from "./AppDropDownList.vue?vue&type=script&lang=ts"
export * from "./AppDropDownList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports